import { Model } from '@vuex-orm/core';

export default class Objektbild extends Model {
  static entity = 'objektbild';
  static primaryKey = 'msid';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {string} */
    this.msid;
    /** @type {string | null} */
    this.mimetype;
    /** @type {string | null} */
    this.crmfilename;
    /** @type {string | null} */
    this.s3filename;
    /** @type {number | null} */
    this.id;
    /** @type {number | null} */
    this.width;
    /** @type {number | null} */
    this.height;
  }

  static fields() {
    return {
      msid: this.string(''),
      mimetype: this.string('').nullable(),
      crmfilename: this.string('').nullable(),
      s3filename: this.string('').nullable(),
      id: this.number(0).nullable(),
      width: this.number(0).nullable(),
      height: this.number(0).nullable()
    };
  }
}
